/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable radix */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { TextField } from '@material-ui/core';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const PriceTypeCustomTextField = (props) => {
  const {
    column,
    type,
    node,
    textAlign,
    value,
    required,
    maxLength,
    disabled = false,
  } = props;
  const compareRebatePriceSerchResult = useSelector(
    (state) =>
      state?.sharedState?.PriceTypeReducer?.compareRebatePriceSerchResult
  );

  const checkedHandler = (e) => {
    const { colId } = column;
    if (type === 'number') {
      const inputValue = e.target.value;
      if (inputValue.match(/^[0-9]+$/)) {
        node.setDataValue(colId, parseInt(inputValue));
      } else if (inputValue === '') {
        node.setDataValue(colId, null);
      }
      optimiseValidationCall(props, compareRebatePriceSerchResult);
    } else {
      const inputValue = e.target.value;
      node.setDataValue(colId, inputValue === '' ? null : inputValue);
      optimiseValidationCall(props, compareRebatePriceSerchResult);
    }
  };

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 300);
    };
  };

  const optimiseValidationCall = useCallback(
    debounce(props.validateBtnDisable),
    []
  );

  return (
    <div
      className={`fullWidth w-100 text-${
        props.textAlign || 'left'
      } td-active-cell ${
        props.required && (!props.value || !props.value.trim())
          ? 'tBill-validate'
          : ''
      }`}
      id='priceType'
    >
      {value && value.length > 23 ? (
        <OverlayTrigger
          placement='bottom'
          overlay={<Tooltip id='filter-tooltip'>{props.value || ''}</Tooltip>}
        >
          <TextField
            fullWidth
            placeholder=''
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              maxLength: props.maxLength || 255,
              'aria-labelledby': 'priceType',
            }}
            InputProps={{ disableUnderline: true }}
            disabled={disabled || false}
            value={value || ''}
            //value={value && value.substring(0, 20) + '...'}
            //title={value || ''}
            onChange={checkedHandler}
            error={required && (!value || !value.trim())}
            helperText=''
          />
        </OverlayTrigger>
      ) : (
        <TextField
          fullWidth
          placeholder=''
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            maxLength: props.maxLength || 255,
            'aria-labelledby': 'priceType',
          }}
          InputProps={{ disableUnderline: true }}
          disabled={disabled || false}
          value={value || ''}
          //title={value || ''}
          onChange={checkedHandler}
          error={required && (!value || !value.trim())}
          helperText=''
        />
      )}
    </div>
  );
};

export default PriceTypeCustomTextField;
